// extracted by mini-css-extract-plugin
module.exports = {"tailA":"tailA_tailA__OKhSx"};